import React, { useContext } from 'react';
export var AppContext = /*#__PURE__*/React.createContext();
export var useAppContext = function useAppContext() {
  return useContext(AppContext);
};
//# sourceMappingURL=AppContext.js.map